<template>
  <transition name="edit-fade" mode="out-in">
    <div class="columns downloads-wrapper" v-if="!edit && !add && selectedGroup === -1" :key="'1'">
      <div class="column is-8 downloads">
        <loader :loading="loading.list" :fixed="false"></loader>
        <div class="field filter">
          <p class="control has-icons-right">
            <input class="input" type="text" :placeholder="$resx('Global.Filter')" v-model="input">
            <span class="icon is-small is-right" @click.prevent="input = ''">
              <font-awesome-icon :icon="icons.delete" />
            </span>
          </p>
        </div>
        <div class="downloads-lists">
          <div v-for="(list, idx) in lists" :key="idx" :class="{'invisible-group': idx === '-1'}">
            <div class="download-group">{{ getGroupName(idx) }} <font-awesome-icon :icon="icons.edit" @click="selectGroup(idx)" /><font-awesome-icon v-if="idx !== '-1' && canDeleteGroup(idx)" :icon="icons.trash" @click="deleteGroup(idx)" /></div>
            <draggable class="downloads-list" :class="{'is-empty': list.length === 0}" @start="drag = true" @end="endDrag" :empty-insert-threshold="50" :disabled="loading.list || input !== ''" group="downloads" :list="list" v-bind="dragOptions">
              <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <div v-for="(download, idx_l) in list" @click="selectDownload(download.ID)" :key="idx_l+1" :id="download.ID" :class="{selected: selected === download.ID}">
                  <div class="icon">
                    <font-awesome-icon :icon="icons.files.pdf" />
                  </div>
                  <div class="name">
                    {{download.Title}}
                  </div>
                  <div class="file">
                    {{ (download.Filename !== "" ? getFilenameFromUrl(download.Filename, true).full : "") }}
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="buttons">
          <button class="button is-fullwidth" @click.prevent="addDownload">
            <span class="icon">
              <font-awesome-icon :icon="icons.add"/>
            </span>
            <span>{{ $resx("Buttons.Add") }}</span>
          </button>
          <button class="button is-fullwidth" @click.prevent="addDownloadGroup">
            <span class="icon">
              <font-awesome-icon :icon="icons.add"/>
            </span>
            <span>{{ $resx("Buttons.AddGroup") }}</span>
          </button>
          <button class="button is-fullwidth" :disabled="(selected !== -1 ? false : 'disabled')" @click.prevent="edit = true, $emit('canClose', false), $store.commit('contentChanged', true)">
            <span class="icon">
              <font-awesome-icon :icon="icons.edit" />
            </span>
            <span>{{ $resx("Buttons.Edit") }}</span>
          </button>
          <button class="button is-fullwidth is-danger" :disabled="(selected !== -1 ? false : 'disabled')" @click.prevent="deleteDownload">
            <span class="icon">
              <font-awesome-icon :icon="icons.delete" />
            </span>
            <span>{{ $resx("Buttons.Delete") }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="columns form-wrapper" v-else :key="'2'">
      <loader :loading="loading.edit" :fixed="false"></loader>
      <form class="column is-8">
        <div v-if="selectedGroup !== -1">
          <div class="tabs">
            <ul>
              <li :class="{'is-active': tabCulture === key}" v-for="(culture, key) in $store.state.cultures" :key="key">
                <a @click.prevent="tabCulture = key">
                  <span class="icon" :class="['flag flag-xs flag-'+key.split('-')[1].toLowerCase()]"></span>
                  <!-- <span>{{ culture }}</span> -->
                </a>
              </li>
            </ul>
          </div>
          <transition name="tab-fade" mode="out-in">
            <div v-if="tabCulture != ''" :key="tabCulture">
              <div class="field">
                <label class="label">{{ $resx("Group.Title") }}</label>
                <div class="control">
                  <input class="input" type="text" v-bind:value="(staticGroup.Cultures[tabCulture] ? staticGroup.Cultures[tabCulture].Title : '')" v-on:input="setValue('Title', $event.target.value)" />
                </div>
              </div>
              <div class="field">
                <label class="label">{{ $resx("Group.Description") }}</label>
                <div class="control">
                  <textarea class="textarea" v-bind:value="(staticGroup.Cultures[tabCulture] ? staticGroup.Cultures[tabCulture].Description : '')" v-on:input="setValue('Description', $event.target.value)"></textarea>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div v-else>
          <div class="field">
            <label class="label">{{ $resx("Downloads.Link") }}</label>
            <div class="field has-addons">
              <div class="control is-expanded has-icons-left">
                <span class="icon is-small is-left">
                  <font-awesome-icon :icon="icons.file" />
                </span>
                <label class="input-div">{{ (staticDownload.Filename !== "" ? getFilenameFromUrl(staticDownload.Filename, true).fullUrl : "") }}
                <input class="input" type="file" ref="downloadLink" v-on:change="changeFileInput" />
                </label>
              </div>
              <div class="control">
                <a class="button is-danger" @click.prevent="deleteFile">
                  <font-awesome-icon :icon="icons.trash" />
                </a>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $resx("Downloads.Title") }}</label>
            <div class="control">
              <input class="input" type="text" ref="downloadTitle" v-bind:value="staticDownload.Title" v-on:input="staticDownload.Title = $event.target.value" />
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $resx("Downloads.Description") }}</label>
            <div class="control">
              <textarea class="textarea" ref="downloadDescription" v-bind:value="staticDownload.Description" v-on:input="staticDownload.Description = $event.target.value"></textarea>
            </div>
          </div>
        </div>
      </form>
      <div class="column is-4">
        <div class="buttons">
          <button class="button is-fullwidth is-success" @click.prevent="submitDownload('submit')" :disabled="(submitEnabled ? false : 'disabled')">
            <span>{{ $resx("Buttons.Save") }}</span>
          </button>
          <button class="button is-fullwidth" @click.prevent="submitDownload('cancel')">
            <span>{{ $resx("Buttons.Cancel") }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import { faToggleOn, faToggleOff, faPlus, faPencil, faTimes, faFilePdf, faFile, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import draggable from 'vuedraggable'
import { getFilenameFromUrl } from '@/mixins/getFilenameFromUrl.js'
import { confirm } from '@/mixins/confirm.js'
import loader from '@/components/Loader.vue'

export default {
  name: 'modalContentDownloads',
  data () {
    return {
      loading: {
        list: false,
        edit: false
      },
      input: '',
      selected: -1,
      drag: false,
      icons: {
        toggleOn: faToggleOn,
        toggleOff: faToggleOff,
        add: faPlus,
        edit: faPencil,
        delete: faTimes,
        file: faFile,
        trash: faTrashAlt,
        files: {
          pdf: faFilePdf
        }
      },
      add: false,
      edit: false,
      selectedGroup: -1,
      tabCulture: '',
      staticDownload: false,
      staticGroup: false,
      templates: {
        Download: {
          ID: false,
          Title: '',
          GroupId: '-1',
          Culture: '',
          Filename: ''
        },
        Group: {
          ID: false,
          Cultures: {}
        }
      }
    }
  },
  mixins: [confirm, getFilenameFromUrl],
  components: {
    draggable,
    loader
  },
  computed: {
    lists () {
      var self = this
      var tmp = {}
      self.$store.state.downloads.forEach((download) => {
        if (download.Culture === self.$store.state.language && (self.input === '' || download.Title.toLowerCase().indexOf(self.input.toLowerCase()) > -1)) {
          if (!tmp.hasOwnProperty(download.GroupId)) {
            tmp[download.GroupId] = []
          }
          tmp[download.GroupId].push(download)
        }
      })
      self.$store.state.downloadGroups.forEach((group) => {
        if (!tmp.hasOwnProperty(group.ID)) {
          tmp[group.ID] = []
        }
      })
      return tmp
    },
    submitEnabled () {
      if (this.selectedGroup === 'new') {
        return JSON.stringify(this.staticGroup) !== JSON.stringify(this.templates.Group)
      } else if (this.selectedGroup !== -1) {
        return JSON.stringify(this.staticGroup) !== JSON.stringify(this.selectedDownloadGroup)
      } else if (this.add) {
        return this.staticDownload.Filename !== ''
      } else {
        return this.staticDownload.Filename !== '' && !(JSON.stringify(this.staticDownload) === JSON.stringify(this.selectedDownload))
      }
    },
    selectedDownload () {
      var self = this
      var download = self.$store.state.downloads.find((download) => {
        return download.ID === self.selected
      })
      return download
    },
    selectedDownloadGroup () {
      var self = this
      var sel = self.$store.state.downloadGroups.find((group) => {
        return group.ID === Number(self.selectedGroup)
      })
      return sel
    },
    dragOptions () {
      return {
        animation: 200,
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    canDeleteGroup: function (idx) {
      var self = this
      var canDelete = true
      for (var i = 0; i < self.$store.state.downloads.length; i++) {
        if (canDelete && Number(self.$store.state.downloads[i].GroupId) === Number(idx)) {
          canDelete = false
          break
        }
      }
      return canDelete
    },
    getGroupName: function (id) {
      var self = this
      var name = ''
      self.$store.state.downloadGroups.forEach((group) => {
        if (group.ID === Number(id)) {
          if (group.Cultures[self.$store.state.language]) {
            name = group.Cultures[self.$store.state.language].Title
          }
        }
      })
      return name
    },
    getNextGroupId: function () {
      var self = this
      var newId = 0
      self.$store.state.downloadGroups.forEach((group) => {
        if (newId < group.ID) {
          newId = group.ID
        }
      })
      return (newId + 1)
    },
    setValue: function (target, value) {
      var self = this
      var tmp = JSON.parse(JSON.stringify(self.staticGroup))
      if (!tmp.Cultures.hasOwnProperty(self.tabCulture)) {
        tmp.Cultures[self.tabCulture] = {
          Title: '',
          Description: ''
        }
      }
      tmp.Cultures[self.tabCulture][target] = value

      if (tmp.Cultures[self.tabCulture].Title === '' && tmp.Cultures[self.tabCulture].Description === '') {
        delete tmp.Cultures[self.tabCulture]
      }
      self.staticGroup = tmp
    },
    endDrag: function (event) {
      var self = this
      self.loading.list = true
      var data = {}
      for (var key in self.lists) {
        if (!data.hasOwnProperty(key)) {
          data[key] = []
        }
        for (var i = 0; i < self.lists[key].length; i++) {
          data[key].push(self.lists[key][i].ID)
        }
      }

      self.drag = false
      self.$http({
        method: 'PUT',
        url: '/downloads/order',
        name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
        api: 'website',
        data: data
      }).then(function () {
        self.$store.dispatch('getSitemap', true).then(function () {
          self.loading.list = false
        })
      }).catch(function (err) {
        self.$store.dispatch('setSnack', {
          message: err.message
        })
        self.loading.list = false
      })
    },
    unselectDownload: function () {
      this.selected = -1
    },
    selectDownload: function (idx) {
      var self = this
      if (self.selected === idx) {
        self.selected = -1
        self.staticDownload = false
      } else {
        self.selected = idx
        self.staticDownload = JSON.parse(JSON.stringify(self.selectedDownload))
      }
    },
    selectGroup: function (id, list) {
      var self = this
      self.selectedGroup = id
      self.tabCulture = Object.keys(self.selectedDownloadGroup.Cultures)[0]
      self.staticGroup = JSON.parse(JSON.stringify(self.selectedDownloadGroup))
      self.$emit('canClose', false)
      self.$store.commit('contentChanged', true)
    },
    deleteGroup: function (id) {
      var self = this
      if (Number(id) !== -1) {
        self.confirm({
          message: self.$resx('Global.AreYouSure'),
          buttons: [
            {
              name: self.$resx('Buttons.Cancel'),
              class: 'is-pulled-left'
            },
            {
              name: self.$resx('Buttons.Yes'),
              class: 'is-pulled-right is-danger',
              action: function () {
                self.loading.list = true
                self.$http({
                  method: 'DELETE',
                  url: '/DownloadGroup/' + id,
                  name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                  api: 'website'
                }).then(function (response) {
                  self.$store.dispatch('getSitemap', true).then(function () {
                    self.loading.list = false
                    self.$store.dispatch('setSnack', {
                      message: self.$resx('Group.Removed')
                    })
                    self.resetSelected()
                  })
                }).catch(function (err) {
                  self.$store.dispatch('setSnack', {
                    message: err.message
                  })
                  self.resetSelected()
                })
              }
            }
          ]
        })
      }
    },
    addDownload: function () {
      this.staticDownload = JSON.parse(JSON.stringify(this.templates.Download))
      this.add = true
      this.$emit('canClose', false)
      this.$store.commit('contentChanged', true)
    },
    addDownloadGroup: function () {
      var self = this
      self.staticGroup = JSON.parse(JSON.stringify(this.templates.Group))
      self.selectedGroup = 'new'
      self.tabCulture = Object.keys(self.$store.state.cultures)[0]
      self.$emit('canClose', false)
      self.$store.commit('contentChanged', true)
    },
    changeFileInput: function (e) {
      this.staticDownload.Filename = e.target.files[0].name
    },
    deleteFile: function () {
      var self = this
      self.confirm({
        message: self.$resx('Global.AreYouSure'),
        buttons: [
          {
            name: self.$resx('Buttons.Cancel'),
            class: 'is-pulled-left'
          },
          {
            name: self.$resx('Buttons.Yes'),
            class: 'is-pulled-right is-danger',
            action: function () {
              self.$refs.downloadLink.value = ''
              self.staticDownload.Filename = ''
            }
          }
        ]
      })
    },
    deleteDownload: function () {
      var self = this; var message

      if (self.selected !== -1) {
        message = self.$resx('Global.AreYouSure')
        self.confirm({
          message: message,
          buttons: [
            {
              name: 'Annuleer',
              class: 'is-pulled-left'
            },
            {
              name: 'Verwijder',
              class: 'is-pulled-right is-danger',
              action: function () {
                self.loading.list = true
                var download = self.selectedDownload
                self.$http({
                  method: 'DELETE',
                  url: '/downloads/' + download.ID,
                  name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                  api: 'website'
                }).then(function (response) {
                  self.$store.dispatch('getSitemap', true).then(function () {
                    self.loading.list = false
                    self.$store.dispatch('setSnack', {
                      message: self.$resx('Downloads.Removed')
                    })
                    self.resetSelected()
                  })
                }).catch(function (err) {
                  self.$store.dispatch('setSnack', {
                    message: err.message
                  })
                  self.resetSelected()
                  self.loading.list = false
                })
              }
            }
          ]
        })
      }
    },
    resetSelected: function () {
      var self = this
      self.staticDownload = false
      self.staticGroup = false
      self.selectedGroup = -1
      self.selected = -1
      self.add = false
      self.edit = false
      self.$emit('canClose', true)
      self.$store.commit('contentChanged', false)
    },
    submitDownload: function (action) {
      var self = this
      var method

      if (action === 'submit') {
        self.loading.edit = true

        if (self.selectedGroup !== -1) {
          // group
          method = 'PUT'
          var group = self.staticGroup
          if (self.selectedGroup === 'new') {
            method = 'POST'
            group.ID = self.getNextGroupId()
          }
          self.$http({
            method: method,
            url: '/DownloadGroup',
            name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
            api: 'website',
            data: group
          }).then(function (response) {
            self.$store.dispatch('getSitemap', true).then(function () {
              self.$store.dispatch('setSnack', {
                message: self.$resx('Group.SingleSaved')
              })
              self.loading.edit = false
              self.resetSelected()
            })
          }).catch(function (err) {
            self.$store.dispatch('setSnack', {
              message: err.message
            })
            self.loading.edit = false
            self.resetSelected()
          })
        } else {
          // save download
          if (self.add) {
            method = 'POST'
          } else {
            method = 'PUT'
          }
          var data = JSON.parse(JSON.stringify(self.staticDownload))

          new Promise(function (resolve) {
            if (self.edit && data.Filename !== self.selectedDownload.Filename) {
              var file = self.getFilenameFromUrl(self.selectedDownload.Filename, true)
              self.$store.dispatch('deleteFile', file).then(function (deleted) {
                resolve()
              })
            } else {
              resolve()
            }
          }).then(function () {
            new Promise(function (resolve) {
              if (self.add || data.Filename !== self.selectedDownload.Filename) {
                var formData = new FormData()
                formData.append('FormFile', self.$refs.downloadLink.files[0])

                self.$http({
                  method: 'POST',
                  url: '/general/file',
                  name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                  api: 'website',
                  data: formData,
                  headers: { 'Content-Type': 'multipart/form-data' }
                }).then(function (response) {
                  resolve(response.data)
                }).catch(function (err) {
                  self.$store.dispatch('setSnack', {
                    message: err.message
                  })
                  resolve({
                    FilePath: '',
                    Filesize: ''
                  })
                })
              } else {
                resolve({
                  FilePath: self.selectedDownload.Filename,
                  Filesize: self.selectedDownload.Filesize
                })
              }
            }).then(function (fileData) {
              var values = {
                Title: data.Title,
                Description: data.Description,
                Filename: fileData.FilePath,
                Filesize: fileData.Filesize,
                Culture: self.$store.state.language
              }
              if (self.edit) {
                values.ID = data.ID
                values.GroupId = data.GroupId
              }
              self.$http({
                method: method,
                url: '/downloads',
                name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                api: 'website',
                data: values
              }).then(function (response) {
                self.$store.dispatch('getSitemap', true).then(function () {
                  self.loading.edit = false
                  self.$store.dispatch('setSnack', {
                    message: self.$resx('Downloads.SingleSaved')
                  })
                  self.resetSelected()
                })
              }).catch(function (err) {
                self.$store.dispatch('setSnack', {
                  message: err.message
                })
                self.resetSelected()
              })
            })
          })
        }
      } else {
        self.resetSelected()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.edit-fade-enter-active,
.edit-fade-leave-active,
.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.2s;
}
.edit-fade-enter,
.edit-fade-leave-to,
.tab-fade-enter,
.tab-fade-leave-to {
  opacity: 0;
}
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.3;
}

.downloads-wrapper{
  height: 450px;

  .downloads{
    .filter{
      display: inline-block;
      vertical-align: top;
      width: 100%;//calc(100% - 160px);
      margin-right: 10px;
      margin-bottom: 0;

      .control{
        .icon{
          pointer-events: all;
          cursor: pointer !important;
        }
      }
    }
    .downloads-header{
      display: inline-block;
      vertical-align: bottom;
      width: 150px;

      // .select, select{
      //   width: 100%;
      // }
    }
    .downloads-lists{
      height: 406px;
      overflow: auto;
      margin-top: 10px;
      .download-group{
        padding: 10px 10px 5px 10px;
        font-weight: 600;

        &:hover{
          svg{
            opacity: .4;
          }
        }

        svg{
          opacity: 0;
          transition: all 150ms ease-in-out;
          margin-left:10px;
          cursor: pointer;
          &:hover{
            opacity: 1;
          }
        }
      }

      .invisible-group{
        .downloads-list{
          background-color: $white-bis;
          border: 1px dashed $grey-lighter;
          padding: 10px;
          border-radius: 4px;

          span{
            >div{
              opacity: 0.4;
            }
          }
        }
      }

      .downloads-list{
        span{
          min-height: 50px;
          display: inline-block;
          width: 100%;
          >div{
            display: inline-block;
            width: 100%;
            height: 50px;
            border: 1px solid $grey-lighter;
            background-color: $grey-bg;
            border-radius: 4px;
            padding: 10px 20px;
            line-height: 30px;
            cursor: pointer;

            + div{
              margin-top: 10px;
            }

            &.selected{
              border-color: $grey;
            }

            .icon{
              display: inline-block;
              vertical-align: top;
              width: 40px;
              font-size: 28px;
            }
            .name{
              display: inline-block;
              vertical-align: top;
              width: calc(50% - 20px);
              @include text-overflow;
            }
            .file{
              display: inline-block;
              vertical-align: top;
              width: calc(50% - 20px);
              @include text-overflow;
            }
            .size{
              display: inline-block;
              vertical-align: top;
              width: 40px;
              opacity: 0.4;
              @include text-overflow;
            }
            .culture{
              display: inline-block;
              vertical-align: bottom;
              width: 40px;
              span{
                vertical-align: middle;
              }
            }
          }
        }
      }
      .downloads-list.is-empty{
        span{
          min-height: 0px;
        }
      }

    }
  }
}
.form-wrapper{
  >.is-8{
    height: 450px;
    overflow: auto;

    .input-div{
      display: block;
      flex: 1;
      cursor: pointer;
      -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      background-color: #fcfdfd;
      border-radius: 4px 0px 0px 4px;
      align-items: center;
      border: 1px solid #dbdbdb;
      height: 2.25em;
      justify-content: flex-start;
      line-height: 1.5;
      padding-bottom: calc(0.375em - 1px);
      padding-left: 2.25em;
      padding-right: calc(0.625em - 1px);
      padding-top: calc(0.375em - 1px);
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      input{
        position: absolute;
        left: 0;
        opacity: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        cursor: pointer;
      }
    }
  }

  .field{
    &.cultures{
      .radio{
        + .radio{
          margin-left: 15px;
        }
        .icon{
          margin: 0px 5px -7px 5px;
          vertical-align: unset;
        }
      }
    }
  }
}
</style>
